import ComponentManager from '@/Management/ComponentManager';
import ContainerViewModel from '@/ViewModels/Controls/ContainerViewModel';
import { ITabStripTab2ViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';
import type TabStrip2ViewModel from '@/ViewModels/Controls/TabStrip2ViewModel';

export default class TabStripTab2ViewModel extends ContainerViewModel {

    /**
     * Gibt an, ob der Tab aktiv ist
     */
    public isActive: KnockoutObservable<boolean>;

    /**
     * Definiert den Namen des inneren Layouts
     */
    public layout: string;

    /**
     * Referenz auf den TabStrip
     */
    public tabStrip: TabStrip2ViewModel;

    public __createdFactories: any;

    /**
    * Gibt den Index des Tabs im Container in der UI an.
     */
    public uiIndex: number;

    /**
     * Das ViewModel für ein TabStripTab2
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: ITabStripTab2ViewModelConstructorParameter) {
        super(params);

        this.isActive = this.observableOrDefault(params.isActive, false);
        this.context = this.paramOrDefault(params.context, null);
        this.layout = this.paramOrDefault(params.layout, 'NoneLayout');
        this.detailViewItems = this.paramOrDefault(params.detailViewItems, []);
        this.detailViewGroups = this.paramOrDefault(params.detailViewGroups, []);
        this.link = this.paramOrDefault(params.link, null);
        this.tabStrip = this.paramOrDefault(params.tabStrip, null);
        this.uiIndex = -1;
        this.__createdFactories = [];

        this.undisposeProperties.push("tabStrip");
    }
}

ComponentManager.setViewModel('TabStripTab2ViewModel', TabStripTab2ViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');